module.exports = __webpack_public_path__ + "img/phone-bg-new.a7a33300.jpg";